import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Asset} from '@app/asset';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class EmbedService {
    constructor(private http: HttpClient) {}

    get(token: string): Observable<Asset> {
        const url = `/api/embed/${token}/`;
        return this.http.get<Asset>(url);
    }
}
